import styled from "styled-components";

const H1BigEmphasis = styled.h1`
  font-weight: 600;
  font-size: 180px;
  line-height: 1;
  margin: 0;
`;

const H1Big = styled.h1`
  font-weight: normal;
  font-size: 180px;
  line-height: 1;
  margin: 0;
  font-family: "Euclid Flex", var(--headerFont);
`;

const H1 = styled.h1`
  font-weight: 600;
  font-size: 110px;
  line-height: 1;
  margin: 0;
`;

const H2BigStrong = styled.h2`
  font-weight: 600;
  font-size: 62px;
  line-height: 1.1;
  margin: 0;
`;

const H2Big = styled.h2`
  font-weight: 300;
  font-size: 62px;
  line-height: 1.1;
  margin: 0;
`;

const H2Strong = styled.h2`
  font-weight: bold;
  font-size: 54px;
  line-height: 1.1;
  margin: 0;
`;

const H2 = styled.h2`
  font-weight: 600;
  font-size: 54px;
  line-height: 1.1;
  margin: 0;
`;

const H2Italic = styled.h2`
  font-weight: 600;
  font-size: 54px;
  line-height: 1.1;
  font-style: italic;
  margin: 0;
`;

const H2SmallStrong = styled.h2`
  font-weight: 600;
  font-size: 42px;
  line-height: 1.25;
  margin: 0;
`;

const H2Small = styled.h2`
  font-weight: normal;
  font-size: 42px;
  line-height: 1.25;
  margin: 0;
`;

const H2SmallItalic = styled.h2`
  font-weight: normal;
  font-size: 42px;
  line-height: 1.25;
  font-style: italic;
  margin: 0;
`;

const H3 = styled.h3`
  font-weight: normal;
  font-size: 32px;
  line-height: 1.25;
  letter-spacing: 0.32px;
  margin: 0;
`;

const H3Italic = styled.h3`
  font-weight: normal;
  font-size: 32px;
  font-style: italic;
  line-height: 1.25;
  letter-spacing: 0.32px;
  margin: 0;
`;

const H3Strong = styled.h3`
  font-weight: 600;
  font-size: 32px;
  line-height: 1.25;
  letter-spacing: 0.32px;
  margin: 0;
`;

const H3StrongItalic = styled.h3`
  font-weight: 600;
  font-size: 32px;
  font-style: italic;
  line-height: 1.25;
  letter-spacing: 0.32px;
  margin: 0;
`;

const H3Small = styled.h3`
  font-weight: normal;
  font-size: 24px;
  line-height: 1.3;
  letter-spacing: 0.24px;
  margin: 0;
`;

const H3SmallMedium = styled.h3`
  font-weight: 500;
  font-size: 24px;
  line-height: 1.3;
  letter-spacing: 0.24px;
  margin: 0;
`;

const H3SmallStrong = styled.h3`
  font-weight: bold;
  font-size: 24px;
  line-height: 1.3;
  letter-spacing: 0.24px;
  margin: 0;
`;

const H4BigStrong = styled.h4`
  font-weight: bold;
  font-size: 24px;
  line-height: 1.3;
  letter-spacing: 0.24px;
  margin: 0;
`;

const H4Big = styled.h4`
  font-weight: normal;
  font-size: 24px;
  line-height: 1.3;
  letter-spacing: 0.24px;
  margin: 0;
`;

const H4StrongItalic = styled.h4`
  font-weight: 600;
  font-size: 21px;
  font-style: italic;
  line-height: 1.5;
  letter-spacing: 1.26px;
  text-transform: uppercase;
  margin: 0;
`;

const H4Strong = styled.h4`
  font-weight: 600;
  font-size: 21px;
  line-height: 1.5;
  letter-spacing: 1.26px;
  text-transform: uppercase;
  margin: 0;
`;

const H4Italic = styled.h4`
  font-weight: 500;
  font-size: 21px;
  font-style: italic;
  line-height: 1.5;
  letter-spacing: 1.26px;
  text-transform: uppercase;
  margin: 0;
`;

const H4 = styled.h4`
  font-weight: 500;
  font-size: 21px;
  line-height: 1.5;
  letter-spacing: 1.26px;
  text-transform: uppercase;
  margin: 0;
`;

const H5BigStrong = styled.h5`
  font-weight: bold;
  font-size: 18px;
  line-height: 1.4;
  letter-spacing: 0.36px;
  margin: 0;
`;

const H5BigMedium = styled.h5`
  font-weight: 500;
  font-size: 18px;
  line-height: 1.4;
  letter-spacing: 0.18px;
  margin: 0;
`;

const H5Big = styled.h5`
  font-weight: normal;
  font-size: 18px;
  line-height: 1.4;
  margin: 0;
`;

const P = styled.p`
  font-weight: normal;
  font-size: 18px;
  line-height: 1.4;
  margin: 0;
`;

const H5Strong = styled.h5`
  font-weight: bold;
  font-size: 15px;
  line-height: 1.4;
  letter-spacing: 0.15px;
  margin: 0;
`;

const H5Medium = styled.h5`
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.3px;
  line-height: 1.4;
  margin: 0;
`;

const H5 = styled.h5`
  font-weight: normal;
  font-size: 15px;
  line-height: 1.4;
  letter-spacing: 0.3px;
  margin: 0;
`;

const H5SmallStrong = styled.h5`
  font-weight: bold;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.84px;
  text-transform: uppercase;
  margin: 0;
`;

const H5SmallMedium = styled.h5`
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.84px;
  text-transform: uppercase;
  margin: 0;
`;

const H5Small = styled.h5`
  font-weight: normal;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.84px;
  text-transform: uppercase;
  margin: 0;
`;
const H6Big = styled.h6`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0.01em;
  margin: 0;
`;
const H6Strong = styled.h6`
  font-weight: bold;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.18px;
  margin: 0;
`;

const H6Medium = styled.h6`
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.18px;
  line-height: 1.5;
  margin: 0;
`;

const H6 = styled.h6`
  font-weight: normal;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0.36px;
  margin: 0;
`;

const H6SmallStrong = styled.h6`
  font-weight: bold;
  font-size: 11px;
  line-height: 1;
  margin: 0;
  text-transform: uppercase;
`;

const H6SmallMedium = styled.h6`
  font-weight: 500;
  font-size: 11px;
  letter-spacing: 0.66px;
  line-height: 1.5;
  text-transform: uppercase;
  margin: 0;
`;

const H6Small = styled.h6`
  font-weight: normal;
  font-size: 11px;
  line-height: 1.5;
  letter-spacing: 0.66px;
  text-transform: uppercase;
  margin: 0;
`;

const PH7 = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  margin: 0;
`;

export {
  H1BigEmphasis,
  H1Big,
  H1,
  H2,
  H2Italic,
  H2Strong,
  H2Big,
  H2BigStrong,
  H2SmallStrong,
  H2Small,
  H2SmallItalic,
  H3,
  H3Italic,
  H3Strong,
  H3StrongItalic,
  H3Small,
  H3SmallMedium,
  H3SmallStrong,
  H4BigStrong,
  H4Big,
  H4,
  H4Italic,
  H4Strong,
  H4StrongItalic,
  H5BigStrong,
  H5BigMedium,
  H5Big,
  H5Strong,
  H5Medium,
  H5,
  H5SmallStrong,
  H5SmallMedium,
  H5Small,
  H6Strong,
  H6Medium,
  H6,
  H6SmallStrong,
  H6SmallMedium,
  H6Small,
  H6Big,
  PH7,
  P,
};
